import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

const resources = {
  es: {
    translation: {
      // Menu
      "menu.agro": "Agro",
      "menu.onboarding": "Onboarding",
      "menu.configuracion": "Configuracion",
      "menu.seguridad": "Seguridad",
      "menu.dashboard": "Dashboard",
      "menu.precios": "Precios Mercado",
      "menu.buscarProductor": "Buscar Productor",
      "menu.altaProductor": "Alta Productor",
      "menu.administracion": "Administracion",
      "menu.alta": "Alta",
      "menu.monitoreo": "Monitoreo",
      "menu.tablasGenerales": "Catálogo de Tablas",
      "menu.permisosPorPerfil": "Permisos Por Perfil",
      "menu.usuarios": "Usuarios",
      "menu.auditoriaLogs": "Auditoria Logs",
      // Common
      "common.loading": "Cargando...",
      "common.error": "Error",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.delete": "Eliminar",
      "common.search": "Buscar",
      "common.back": "Volver",
    },
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  })

export default i18n
